export const SOURCE_OPTIONS = ['fb_eou', 'all'];
